import { useEffect, useState } from 'react'
import { Button, Drawer } from '@mui/material'
import LogoutIcon from '@mui/icons-material/Logout'
import NotesIcon from '@mui/icons-material/Notes'
import './style.css'
import UserService, { User } from '../../services/UserService'
import { UserRole } from '../../enums/UserRole'
import { useNavigate } from 'react-router-dom'
import BarChartIcon from '@mui/icons-material/BarChart'
import styles from './DrawerComponent.module.css'
import PeopleIcon from '@mui/icons-material/People'
import AssignmentIcon from '@mui/icons-material/Assignment';
import SettingsIcon from '@mui/icons-material/Settings';
import LeaderboardIcon from '@mui/icons-material/Leaderboard';

export function DrawerComponent() {
  const [abrir, setAbrir] = useState(false)
  const [user, setUser] = useState<User>()
  const navigate = useNavigate()

  useEffect(() => {
    setUser(UserService.getUser())
  }, [])

  function abrirMenu(newAbrir: boolean) {
    setAbrir(newAbrir)
  }

  const ValoresDoMenu = (
    <>
      {abrir ? (
        <>
          <div className={styles.icones}>
            {user?.role?.includes(UserRole.ADMIN) && (
              <Button
                onClick={() => {
                  abrirMenu(false), navigate('/configuracoes')
                }}
              >
                <SettingsIcon className={styles.icon} fontSize='large' />
                Configurações
              </Button>
            )}
            <Button
              onClick={() => {
                abrirMenu(false)
                navigate('/homepage')
              }}
            >
              <NotesIcon className={styles.icon} fontSize='large' />
              Atendimento
            </Button>
            <Button
              onClick={() => {
                abrirMenu(false), navigate('/leadspage')
              }}
            >
              <BarChartIcon className={styles.icon} fontSize='large' />
              Leads
            </Button>
            <Button
              onClick={() => {
                abrirMenu(false), navigate('/clientes')
              }}
            >
              <PeopleIcon className={styles.icon} fontSize='large' />
              Clientes
            </Button>
            <Button
              onClick={()=>{
                abrirMenu(false), navigate('/kanbanPage')
              }}>
              <AssignmentIcon className={styles.icon} fontSize='large' />
                Kanban
            </Button>
            <Button
              onClick={()=>{
                abrirMenu(false), navigate('/netPromoterScore')
              }}>
              <LeaderboardIcon className={styles.icon} fontSize='large' />
                NPS
            </Button>
          </div>
          <div className={styles.container_footer}>
            <Button
              onClick={() => {
                navigate('/')
              }}
            >
              <LogoutIcon className={styles.icon} fontSize='large' />
              Sair
            </Button>
          </div>
        </>
      ) : (
        <>
          <div className={styles.icones}>
            {user?.role?.includes(UserRole.ADMIN) && (
              <SettingsIcon className={styles.icon} fontSize='large' />
            )}
            <NotesIcon className={styles.icon} fontSize='large' />
            <BarChartIcon className={styles.icon} fontSize='large' />
            <PeopleIcon className={styles.icon} fontSize='large' />
            <AssignmentIcon className={styles.icon} fontSize='large' />
            <LeaderboardIcon className={styles.icon} fontSize='large' />
          </div>

          <div className={styles.container_footer}>
            <LogoutIcon className={styles.icon} fontSize='large' />
          </div>
        </>
      )}
    </>
  )

  return (
    <div className={styles.menu_lateral}>
      {abrir === false ? (
        <Drawer
          variant='permanent'
          className={abrir ? styles.menu_aberto : styles.menu_fechado}
          classes={{ paper: abrir ? styles.menu_aberto : styles.menu_fechado }}
          onClick={() => abrirMenu(true)}
        >
          <div className={styles.container_icones}>{ValoresDoMenu}</div>
        </Drawer>
      ) : (
        <Drawer
          open={abrir}
          onClose={() => abrirMenu(false)}
          className={abrir ? styles.menu_aberto : styles.menu_fechado}
          classes={{ paper: abrir ? styles.menu_aberto : styles.menu_fechado }}
        >
          <div className={styles.container_icones}>{ValoresDoMenu}</div>
        </Drawer>
      )}
    </div>
  )
}

export default DrawerComponent